/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import React from "react";

import Icon from "@fitinsur/components/Icon";

import * as S from './styles';

export function ButtonWithIcon({ onClick, width, height, icon, title, simulateQuestion }) {
  return (
    <S.Container
      width={width}
      height={height}
      onMouseOver={(e) => {
        e.currentTarget.style.transform = 'scale(1.03)';
      }}
      onMouseOut={(e) => {
        e.currentTarget.style.transform = 'scale(1)';
      }}
      onClick={onClick}
      simulateQuestion={simulateQuestion}
    >
      <Icon name={icon?.name} width={icon?.width} height={icon?.height} size={10} />
      <S.Title>{title}</S.Title>
    </S.Container>
  )
}
